export default {
  init() {
    window.addEventListener(
      'load',
      function load()
      {
          window.removeEventListener('load', load, false);
          document.body.classList.remove('preload');
      },
      false);
    
    (function() {
    
        var hamburger = {
          navToggle: document.querySelector('.hamburger-icon'),
          overlay: document.querySelector('.mobile-navigation-overlay'), 
          nav: document.querySelector('.mobile-navigation'),
          cross: document.querySelector('.cross'),
          mobileNavLinks: document.querySelectorAll('.mobile-navigation .mobile-nav li a'),
      
          doToggle: function() {
            // e.preventDefault();
            
            // this.navToggle.classList.toggle('expanded');
            if(this.overlay.classList.contains('show')){
                this.overlay.classList.add('hide');
                this.overlay.classList.remove('show');
            }else{
                this.overlay.classList.add('show');
                this.overlay.classList.remove('hide');
            }
    
            if(this.nav.classList.contains('show')){
                this.nav.classList.add('hide');
                this.nav.classList.remove('show');
            }else{
                this.nav.classList.add('show');
                this.nav.classList.remove('hide');
            }
    
          },
        };
      
        hamburger.navToggle.addEventListener('click', function(e) { hamburger.doToggle(e); });
        hamburger.overlay.addEventListener('click', function(e) { hamburger.doToggle(e); });
        hamburger.cross.addEventListener('click', function(e) { hamburger.doToggle(e); });
    
        hamburger.mobileNavLinks.forEach(function(mobileNavLink) {
          mobileNavLink.addEventListener('click', function(e) {
            hamburger.doToggle(e);
          })
        })
      
      }());
    
    // Sticky Header

    window.onscroll = function() {

      var currentScrollPos = window.pageYOffset;
    
      if(currentScrollPos > 120){
        document.getElementsByClassName('header-sticky')['0'].style.top = '0';
      }else{
        document.getElementsByClassName('header-sticky')['0'].style.top = '-75px';
      }
    
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    $(document).on('click', 'a[href^="#"]', function (event) {
      event.preventDefault();
  
      $('html, body').animate({
          scrollTop: $($.attr(this, 'href')).offset().top - 60,
      }, 500);
    });
    
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js